/**
 * ESM shim over the VENDORED measurement module.
 *
 * Everything under `./vendored/` (registry, convert, parse, normalize, format,
 * index and `vectors.json`) is copied BYTE-IDENTICAL from keepr-api
 * (`utils/units/`) and must never be edited here -- `vectors.json` is the
 * lock-step guarantee, driven by `__tests__/units.vectors.test.js`, which also
 * byte-compares every vendored file against the API checkout when it is
 * present. The vendored files are CommonJS because the API runs them under
 * Node; this shim is the only thing standing between them and the app's ESM
 * imports, so app code should always `import { formatMeasurement } from
 * '../utils/units'` and never reach into `vendored/` directly.
 */
import units from './vendored/index';

export const {
	// Registry.
	MEASURES,
	MEASURE_LIST,
	UNITS,
	ALIASES,
	RATE_TIMES,
	getMeasure,
	getUnit,
	unitsOf,
	isUnitOf,
	isComposite,
	resolveUnit,
	isMeasurementValue,
	// Several measures on one element (KPR-1085).
	MAX_MEASURES,
	allowedMeasures,
	isMultiMeasure,
	measureOfUnit,
	unitIdsOf,
	scopeOptions,
	// An element's own units (KPR-1109).
	OWN_PREFIX,
	MAX_OWN_UNITS,
	MAX_OWN_NAME,
	isOwnUnitId,
	ownUnitsOf,
	ownUnitOf,
	resolveOwnUnit,
	ownUnitAsUnit,
	unitIn,
	pluralOf,
	ownUnitIdFor,
	ownUnitIdIn,
	ownNameKey,
	sameOwnUnit,
	ownUnitNameProblem,
	settleOwnUnits,
	sortGroupOf,

	// Conversion.
	toBase,
	fromBase,
	canConvert,
	isDecreasing,
	baseOperator,
	convert,
	splitComposite,
	joinComposite,

	// Parsing.
	parseMeasurement,
	parseMeasurementDetailed,

	// Normalisation.
	normalizeMeasurement,
	readMeasurement,

	// Formatting.
	MAX_PRECISION,
	roundHalfAway,
	formatNumber,
	formatInUnit,
	chooseDisplayUnit,
	formatMeasurement,
} = units;

export default units;
